module.exports = __webpack_public_path__ + "static/img/Logo_Stadt_Zurich_Geomatik_Vermessung.b541f5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo_Stadt_Zurich_Geomatik_Vermessung.jpg
// module id = 131
// module chunks = 1